/**
 * 외부 지도로 길찾기 열기
 * 카카오맵 웹 (https://map.kakao.com/link/map/...) - 모바일에서 "앱으로 열기" 가능
 */

export interface OpenExternalMapParams {
  latitude: number;
  longitude: number;
  /** 장소명/주소 */
  name?: string;
}

/**
 * 카카오맵 웹 - 위치 보기
 * @see https://apis.map.kakao.com/web/guide/
 */
function getKakaoMapWebUrl(params: OpenExternalMapParams): string {
  const { latitude, longitude, name } = params;
  const placeName = name ? encodeURIComponent(name) : encodeURIComponent('방문 상담');
  return `https://map.kakao.com/link/map/${placeName},${latitude},${longitude}`;
}

/**
 * 외부 지도로 길찾기 열기
 * 카카오맵 웹을 새 탭에서 열며, 모바일에서는 웹 페이지에서 "앱으로 열기" 가능
 */
export function openExternalMap(params: OpenExternalMapParams): void {
  const { latitude, longitude } = params;
  if (
    typeof latitude !== 'number' ||
    typeof longitude !== 'number' ||
    isNaN(latitude) ||
    isNaN(longitude)
  ) {
    return;
  }

  const webUrl = getKakaoMapWebUrl(params);
  window.open(webUrl, '_blank', 'noopener,noreferrer');
}
